
import React from 'react';
import { LucideIcon } from 'lucide-react';

interface FeatureBoxProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

const FeatureBox = ({ icon: Icon, title, description }: FeatureBoxProps) => (
  <div className="bg-white p-6 rounded-xl border border-border shadow-sm">
    <h3 className="text-xl font-medium mb-3 flex items-center">
      <Icon className="h-5 w-5 text-primary mr-2" />
      {title}
    </h3>
    <p className="text-muted-foreground">
      {description}
    </p>
  </div>
);

export default FeatureBox;
